export enum IMAGE_ACCEPTED_FILE_EXTENSIONS {
  jpg = 'jpg',
  jpeg = 'jpeg',
  png = 'png',
}
export const IMAGE_FORMATTED_FILES_EXTENSIONS = Object.values(IMAGE_ACCEPTED_FILE_EXTENSIONS)
  .map((ext) => `.${ext}`)
  .join(',')

export const IMAGE_FILE_EXTENSIONS_MIME_TYPE: Record<IMAGE_ACCEPTED_FILE_EXTENSIONS, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
}

export const PHOTO_GALLERY_URLS_UPLOAD_LIMIT = 20
